import React, { useEffect, useReducer, useState } from 'react'
import { Controller } from 'react-hook-form'
import { useForm } from 'react-hook-form/dist/index.ie11'
import { Checkbox, Col, Panel, Row, Table } from 'rsuite'
import InputForm from '../../forms/input/InputForm'
import SaveButton from '../../buttons/saveButton/SaveButton'
import CancelButton from '../../buttons/cancelButton/CancelButton'
import { getSubmitCancelApprover } from '../../../redux/actions/approveProject'
import { doneLoading, startLoading } from '../../../utils/loading'
import notification from '../../../utils/notification'
import { CHECK_STATUS_PROJECT_ACTIVITY_ERR_MSG, ERR_MSG_404 } from '../../../constants/msgText'

export default function CancelApproverListDetail({
  dataList,
  header,
  formSchema,
  setIsShow = () => {},
  approveType,
  projectversionId,
  onSuccess,
  requestId,
}) {
  const { Column, HeaderCell, Cell } = Table
  const [checkedKeys, setCheckedKeys] = useState([])
  const [countSelected, setCountSelected] = useState(0)
  const { control, register, errors, setValue, clearErrors, handleSubmit } = useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [checkedKeysByLevel, setCheckedKeysByLevel] = useState({})
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  // console.log('checkedKeys===>', checkedKeys)
  //console.log('formSchema===>555', formSchema)

  useEffect(() => {
    if(formSchema?.model?.values?.length > 0){
      if(formSchema?.model?.values?.some((item) => item.approveLevel === 2)){
        handleCheckAll(2, true)
      }else if (formSchema?.model?.values?.some((item) => item.approveLevel === 1)) {
        handleCheckAll(1, true)
      }

    }
   
  }, [formSchema])

  // const handleCheckAll = (value, checked) => {
  //   let newArr = []
  //   const checkedKeys = checked ? dataList.map((item) => item.id) : []
  //   dataList.map((item) => {
  //     newArr.push(item.id)
  //   })
  //   setCheckedKeys(checkedKeys)
  //   setCountSelected(newArr.length)
  // }

  // const handleCheckAll = (value, checked) => {
  //   const activeItems = dataList.filter((item) => !item.inActive)

  //   const checkedKeys = checked ? activeItems.map((item) => item.id) : []

  //   setCheckedKeys(checkedKeys)
  //   setCountSelected(checkedKeys.length)
  // }
  // const handleCheck = (value, checked) => {
  //   const nextCheckedKeys = checked
  //     ? [...checkedKeys, value]
  //     : checkedKeys.filter((item) => item !== value)

  //   setCheckedKeys(nextCheckedKeys)
  //   setCountSelected(nextCheckedKeys.length)
  // }

  const handleCheckAll = (approveLevel, checked) => {
    const activeItems = dataList.filter(
      (item) => !item.inActive && item.approveLevel === approveLevel
      // (item) => !item.inActive && item.approveLevel === approveLevel && item.status !== 'อนุมัติ'
    )
    const keys = checked ? activeItems.map((item) => item.id) : []

    setCheckedKeys((prev) => ({
      ...prev,
      [approveLevel]: keys,
    }))
  }

  const handleCheck = (approveLevel, value, checked) => {
    const prevKeys = checkedKeys[approveLevel] || []

    const next = checked ? [...prevKeys, value] : prevKeys.filter((id) => id !== value)

    setCheckedKeys((prev) => ({
      ...prev,
      [approveLevel]: next,
    }))
  }

  const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, level, ...props }) => {
    if (level == 1 && formSchema?.model?.values?.some((item) => item.approveLevel === 2)) {
      return (
        <Cell {...props} style={{ padding: 0 }}>
          <div style={{ lineHeight: '46px' }}>
            {/* ไม่แสดง checkbox ถ้าอนุมัติแล้ว */}
            {props.rowIndex + 1}
          </div>
        </Cell>
      )
    }
    return (
      <Cell {...props} style={{ padding: 0 }}>
        <div style={{ lineHeight: '46px' }}>
          <Checkbox
            disabled={rowData.inActive}
            value={rowData[dataKey]}
            inline
            onChange={onChange}
            checked={checkedKeys.some((item) => item === rowData[dataKey])}
            style={{ marginLeft: -30 }}
          />
          {props.rowIndex + 1}
        </div>
      </Cell>
    )
  }

  const onSubmit = (data) => {
    console.log('data===>', data)
    if (checkedKeys.length == 0) {
      notification.open('error', {
        title: 'กรุณาเลือกผู้มีอำนาจอนุมัติอย่างน้อย 1 รายการ',
        duration: 5000,
      })
      return
    }
    const allCheckedIds = Object.values(checkedKeys).flat()
    const request = {
      comment: data.comment,
      ids: allCheckedIds,
      requestId: requestId,
    }

    console.log('request===>', request)
    handleCallSubmitCancelApprover(request)
  }

  const handleCallSubmitCancelApprover = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      //  console.log('request===>', request)
      const response = await getSubmitCancelApprover(projectversionId, approveType, request)

      if (response.success == true) {
        onSuccess()
        notification.open('success', {
          title: 'ส่งสำเร็จ',
          duration: 5000,
        })
        setIsShow(false)
      } else {
        notification.open('error', {
          title: response.message || response.errorMessage,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)

      notification.open('error', {
        title:
          e?.response?.data?.errors?.message ||
          e?.response?.data?.errorMessage ||
          CHECK_STATUS_PROJECT_ACTIVITY_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      <Panel
        className="grantee-profile-info"
        //shaded
        header={header}
        //bordered
        collapsible
        defaultExpanded
        style={{ marginBottom: 10 }}
      >
        {formSchema?.model?.values?.some((item) => item.approveLevel === 1) && 
        !formSchema?.model?.values?.some(item => item.approveLevel === 2) && (
          <>
            <b>รายชื่อสายอนุมัติ ผู้ให้ความเห็นขั้นต้น</b>
            <Table
              autoHeight
              minHeight={140}
              data={dataList.filter((item) => item.approveLevel === 1)}
              wordWrap
              onDataUpdated={()=>{
                setTimeout(() => {
                  forceUpdate()
                }, 100)
              }}
            >
              <Column width={95} align="center">
                <HeaderCell>
                  {/* <div style={{ lineHeight: '40px' }}>
                    {formSchema?.model?.values?.some((item) => item.approveLevel === 2) ? (
                      <b>ลำดับ</b> // ถ้ามี approveLevel 2 ไม่แสดง checkbox
                    ) : (
                      <Controller
                        name="chkRow"
                        control={control}
                        render={(props) => {
                          return (
                            <Checkbox
                              inline
                              checked={(checkedKeys[1] || []).length > 0}
                              onChange={(e, checked) => handleCheckAll(1, checked)}
                              style={{ marginLeft: -10 }}
                            >
                              <b>ลำดับ</b>
                            </Checkbox>
                          )
                        }}
                      />
                    )}
                  </div> */}
                  <span>ลำดับ</span>
                </HeaderCell>
                <Cell>
                  {(_, index) => {
                      return (
                        index+1
                      )
                  }}
                </Cell>

                {/* <CheckCell
                  checkedKeys={checkedKeys[1] || []}
                  //onChange={(value, checked) => handleCheck(1, value, checked)}
                  onChange={(value, checked) => handleCheckAll(1, checked)}
                  dataKey="id"
                  level={1}
                /> */}
              </Column>

              <Column width={260}>
                <HeaderCell>
                  <span>ชื่อ-สกุล</span>
                </HeaderCell>
                <Cell dataKey="fullName" />
              </Column>
              <Column width={320}>
                <HeaderCell>
                  <span>ตำแหน่ง</span>
                </HeaderCell>
                <Cell dataKey="position" />
              </Column>
              {/* <Column width={180}>
              <HeaderCell>
                <span>สิทธิ์การอนุมัติ</span>
              </HeaderCell>
              <Cell dataKey="approveLevelName" />
            </Column> */}
              <Column minWidth={120} flexGrow={1}>
                <HeaderCell>
                  <span>วันที่อนุมัติ</span>
                </HeaderCell>
                <Cell dataKey="approvedDate" />
              </Column>
              <Column minWidth={100} flexGrow={1}>
                <HeaderCell>
                  <span>สถานะ</span>
                </HeaderCell>
                <Cell dataKey="status" />
                {/* <Cell>
                {(rowData) => {
                  if (rowData.inActive == true)
                    return (
                      <>
                        <span>ยกเลิก</span>
                      </>
                    )
                }}
              </Cell> */}
              </Column>
            </Table>
            <br />
            <br />
          </>
        )}

        {formSchema?.model?.values?.some((item) => item.approveLevel === 2) && (
          <>
            <b>รายชื่อสายอนุมัติ ผู้มีอำนาจอนุมัติ</b>
            <Table
              autoHeight
              minHeight={100}
              data={dataList.filter((item) => item.approveLevel === 2)}
              wordWrap
              onDataUpdated={()=>{
                setTimeout(() => {
                  forceUpdate()
                }, 100)
              }}
            >
              <Column width={95} align="center">
                <HeaderCell>
                  {/* <div style={{ lineHeight: '40px' }}>
                    {dataList.some(
                      (item) =>
                        !item.inActive && item.status !== 'อนุมัติ' && item.approveLevel === 2
                    ) ? (
                      <Controller
                        name="chkRow"
                        control={control}
                        render={(props) => {
                          return (
                            <Checkbox
                              inline
                              checked={(checkedKeys[2] || []).length > 0}
                              onChange={(e, checked) => handleCheckAll(2, checked)}
                              style={{ marginLeft: -10 }}
                            >
                              <b>ลำดับ</b>
                            </Checkbox>
                          )
                        }}
                      />
                    ) : (
                      <b>ลำดับ</b>
                    )}
                  </div> */}
                  <span>ลำดับ</span>
                </HeaderCell>
                <Cell>
                  {(_, index) => {
                      return (
                        index+1
                      )
                  }}
                </Cell>

                {/* <CheckCell
                  checkedKeys={checkedKeys[2] || []}
                  onChange={(value, checked) => handleCheck(2, value, checked)}
                  dataKey="id"
                  level={2}
                /> */}
              </Column>

              <Column width={260}>
                <HeaderCell>
                  <span>ชื่อ-สกุล</span>
                </HeaderCell>
                <Cell dataKey="fullName" />
              </Column>
              <Column width={320}>
                <HeaderCell>
                  <span>ตำแหน่ง</span>
                </HeaderCell>
                <Cell dataKey="position" />
              </Column>
              {/* <Column width={180}>
                <HeaderCell>
                  <span>สิทธิ์การอนุมัติ</span>
                </HeaderCell>
                <Cell dataKey="approveLevelName" />
              </Column> */}
              <Column minWidth={120} flexGrow={1}>
                <HeaderCell>
                  <span>วันที่อนุมัติ</span>
                </HeaderCell>
                <Cell dataKey="approvedDate" />
              </Column>
              <Column minWidth={100} flexGrow={1}>
                <HeaderCell>
                  <span>สถานะ</span>
                </HeaderCell>
                <Cell dataKey="status" />
                {/* <Cell>
              {(rowData) => {
                if (rowData.inActive == true)
                  return (
                    <>
                      <span>ยกเลิก</span>
                    </>
                  )
              }}
            </Cell> */}
              </Column>
            </Table>
            <br />
          </>
        )}
        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <InputForm
              schema={formSchema?.model?.comment}
              rows={3}
              componentClass="textarea"
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />
          </Col>
        </Row>
        <Row style={{ textAlign: 'right', marginTop: 20 }}>
          <SaveButton onClick={handleSubmit(onSubmit)}>ยืนยัน</SaveButton>
          <CancelButton
            // onClick={() => {
            //  isShow==false
            // }}
            onClick={() => {
              setIsShow(false)
            }}
          >
            ปิด
          </CancelButton>
        </Row>
      </Panel>
    </>
  )
}
